var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconHeading(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 15.667,
    viewBox: "0 0 16 15.667",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_Heading",
    d: "M-1062.473-400.333a.526.526,0,0,1-.526-.526.526.526,0,0,1,.526-.526h10.737a.525.525,0,0,1,.526.526.525.525,0,0,1-.526.526Zm0-3.036a.526.526,0,0,1-.526-.526.526.526,0,0,1,.526-.526h13.894a.525.525,0,0,1,.526.526.525.525,0,0,1-.526.526Zm0-3.158a.526.526,0,0,1-.526-.526.526.526,0,0,1,.526-.527h13.894a.525.525,0,0,1,.526.527.525.525,0,0,1-.526.526Zm0-3.158a.526.526,0,0,1-.526-.526v-5.263a.527.527,0,0,1,.526-.527h14.947a.527.527,0,0,1,.526.527v5.263a.526.526,0,0,1-.526.526Zm.868-1.245h13.276v-3.756H-1061.6Z",
    transform: "translate(1063 416)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHeading);
export default __webpack_public_path__ + "static/media/Icon_Heading.495b5492.svg";
export { ForwardRef as ReactComponent };